// extracted by mini-css-extract-plugin
export default {"box":"RemoveConstant_box__rLg3I","selectTitle":"RemoveConstant_selectTitle__fzD3n","title":"RemoveConstant_title__oXHSB","inputTitle":"RemoveConstant_inputTitle__4GwnV"};